import React, { useState } from "react";
import "./webview.css";
import Icon from "../../dashboard/Icon/Icon";
import analytics from "../../utils/analytics";

export default function WebView({ configData = {} }) {
  const { config = {} } = configData;
  const src = config?.navigateTo || "https://run.crm4b2c.com/a/HomeBuilder";
  const title = config?.name;
  const [zoomScale, setZoomScale] = useState("1.0");
  const [zoomPercentage, setZoomPercentage] = useState("100%");

  const handleZoomIn = () => {
    const newZoom = (Math.min(Number(zoomScale) + 0.1, 1.5)).toFixed(1);
    setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
    setZoomScale(newZoom);

    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent("webview widget zoomed in", analyticsData);
  };

  const handleZoomOut = () => {
    const newZoom = (Math.max(Number(zoomScale) - 0.1, 0.5)).toFixed(1);
    setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
    setZoomScale(newZoom);

    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent("webview widget zoomed out", analyticsData);
  };
  const openInNewWindow = () => {
    window.open(src, "_blank", "noopener,noreferrer");
    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent("webview widget goto button clicked", analyticsData);
  };

  return (
    <div className={`webview-widget widget-container ${title && "show-frame"}`}>
      <button
        onClick={openInNewWindow}
        className="navigate-button"
        aria-label="Open in new window"
      >
        <Icon
          src={`images/${"lsq_external_link_white"}.svg`}
          alt="icon"
          className="icon"
          isWidgetIcon={false}
        />
      </button>
      <div className="zoom-controls">
        <div onClick={handleZoomIn}>+</div>
        <div onClick={handleZoomOut}>-</div>
      </div>
      {title && (
        <div className="title overflow-ellipsis ng_h_5_sb">
          <label className="overflow-ellipsis ng_sh_sb" title={config?.name}>
            {title}
          </label>
        </div>
      )}
      <div className="frame">
        <iframe
          target="_parent"
          src={src}
          role="web-view"
          title={title}
          style={{ width: zoomPercentage, height: zoomPercentage, transform: `scale(${zoomScale})`, transformOrigin: '0% 0%' }}
        ></iframe>
      </div>
    </div>
  );
}
